import type { AxiosRequestConfig } from 'axios'
import Axios from 'axios'
import { env } from '@/env'
import { apiUrl } from '@/lib/appConfig'
import { ensureSlash } from '@/lib/ensure-slash'

let authToken: string | undefined

export const setAuthToken = (token?: string) => {
	authToken = token
}

export const AXIOS_INSTANCE = Axios.create({
	baseURL: ensureSlash(env.VITE_API_URL, false),
})

AXIOS_INSTANCE.interceptors.request.use((config) => {
	config.baseURL = apiUrl.state || ensureSlash(env.VITE_API_URL, false)

	if (authToken) {
		config.headers.set('Authorization', `Bearer ${authToken}`)
	}

	return config
})

type CancelablePromise<T> = Promise<T> & {
	cancel: () => void
}

export const customInstance = <T>(
	config: AxiosRequestConfig,
	options?: AxiosRequestConfig,
): CancelablePromise<T> => {
	const controller = new AbortController()

	const promise = AXIOS_INSTANCE({
		...config,
		...options,

		// Ein bereits vom Aufrufer übergebenes Signal bevorzugen.
		signal: options?.signal ?? config.signal ?? controller.signal,
	}).then(({ data }) => data as T) as CancelablePromise<T>

	promise.cancel = () => {
		// controller.abort('Query was cancelled')
	}

	return promise
}
